/**
 * Adds class to blocks that require :has css selector
 * for browsers that don't support :has selector.
 */
export const InitCSSHasSelectorHelper = () => {
  const els = document.querySelectorAll(".split_bg_container, .animated_collage, .cta_banner, .post_feed");
  if(els){
    els.forEach((el, index) => {
      const pageSection = el.closest('.page-section');
      if(pageSection && !el.classList.contains('cta_banner')){
        // Split bg helper
        if(el.classList.contains('split_bg_container')){
          if(!el.nextElementSibling && el.classList.contains('alignment-bottom')){
            pageSection.classList.add('has_split_bg_last_child');
          }
  
          if(!el.previousElementSibling && el.classList.contains('alignment-top')){
            pageSection.classList.add('has_split_bg_first_child');
          }
        }

        // Animated Collage helper
        else if(el.classList.contains('animated_collage')){
          pageSection.classList.add('has_animated_collage');
        }

        // Post Feed Grid helper
        else if(el.classList.contains('post_feed') && el.parentNode.firstElementChild == el){
          pageSection.classList.add('has_first_child_post_feed');
        }
      }

      // Collage banner hover detection helper
      else if(el.classList.contains('cta_banner')){
        const cta = el.querySelector('.btn');
        if(cta){
          cta.addEventListener('mouseenter', () => {
            el.classList.add('hovered');
          });

          cta.addEventListener('focus', () => {
            el.classList.add('hovered');
          });

          cta.addEventListener('mouseleave', () => {
            el.classList.remove('hovered');
          });

          cta.addEventListener('blur', () => {
            el.classList.remove('hovered');
          });
        }
      }
    });
  }
}

